'use strict';

class DesembolsoController {
  constructor($scope, Proyecto, _, Datetime,Storage,DataService,Loading,Message,$state,Usuarios) {
    'ngInject';
    this.$scope = $scope;
    this.Proyecto = Proyecto;
    this._ = _;
    this.Datetime = Datetime;
    this.Storage = Storage;
    this.DataService = DataService;
    this.Loading = Loading;
    this.Message = Message;
    this.$state = $state;
    this.Usuarios = Usuarios
  }

  $onInit() {
    this.usuario = this.Storage.getUser();
    this.ordenProcederOriginal = this.proyecto.orden_proceder;
    this.archivos = {
        urlDocOrdenProceder: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/ODP` : '',
        urlDocOrdenProcederDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/ODP/descargar` : '',
      }
    this.prepararValidacionesFecha();
  }

  $onChanges() {
    this.$scope.$watch('$ctrl.proyecto.adj.orden_proceder', () => {
      this.proyecto.orden_proceder = this.ordenProcederOriginal;
      // if (this.proyecto.adj) {
      //   console.log(new Date(this.proyecto.adj.orden_proceder), this.proyecto.orden_proceder, this.proyecto.adj.orden_proceder < this.proyecto.orden_proceder);
      //   console.log(this.ordenProcederOriginal);
      // }
      if (this.proyecto.adj && this.proyecto.adj.orden_proceder) {
        if (!this.proyecto.orden_proceder || this.proyecto.adj.orden_proceder < this.proyecto.orden_proceder) {
          this.proyecto.orden_proceder = this.proyecto.adj.orden_proceder
        } else {
          this.proyecto.orden_proceder = this.ordenProcederOriginal;
        }
      }
    });
  }

  prepararValidacionesFecha() {
    let fechaDesde, mensajeError = 'La fecha debe ser mayor a la fecha';
    if (this.tieneBoletas()) {
      fechaDesde = this.fechaMasAntiguaDeBoletas();
      mensajeError = `${mensajeError} de inicio de la boleta de anticipo más antigua`
    } else if (this.proyecto.tipo === 'TP_CIF') {
      fechaDesde = this.proyecto.fecha_desembolso;
      mensajeError = `${mensajeError} del desembolso`
    } else {
      fechaDesde = this.proyecto.convenio.fecha_suscripcion;
      mensajeError = `${mensajeError} del convenio`
    }
    fechaDesde = this.Datetime.getFormatDate(fechaDesde);
    this.validacion = {
      fecha_minima: this.Datetime.addDaysToDate(angular.copy(fechaDesde), 1),
      mensaje_fecminima: `${mensajeError} (${this.Datetime.parseDate(fechaDesde, '/')})`
    };
  }

  tieneBoletas() {
    return this.proyecto.boletas.length > 0;
  }

  fechaMasAntiguaDeBoletas() {
    return this._.sortBy(this.proyecto.boletas, (boleta) => {
      return boleta.fecha_inicio_validez;
    })[0].fecha_inicio_validez;
  }

  tieneSupervisiones() {
    // console.log("tieneSupervisiones : ",(this.proyecto && this.proyecto.supervisiones && this.proyecto.supervisiones.length > 0))
    return this.proyecto && this.proyecto.supervisiones && this.proyecto.supervisiones.length > 0;
  }

  tieneOrdenProceder() {
    // this.$log.log("tieneOrdenProceder : ");
    return this.ordenProcederOriginal ? true : false;
  }


  guardarDatos(){
     // console.log(this.proyecto,"proyecto seguimiento")
    this.datos = {
      id_proyecto : this.proyecto.id_proyecto,
      orden_proceder : this.proyecto.orden_proceder,
      doc_orden_proceder : this.proyecto.doc_orden_proceder,
      obs_orden_proceder : this.proyecto.obs_orden_proceder,
      _usuario_modificacion: this.usuario.id_usuario
    };

    // console.log('datos para enviar : ', this.datos)
    this.Loading.show('Guardando',true)
    this.DataService.post(`proyectos/ordenProceder`, this.datos)
      .then(response=>{
        if(response){
          this.Message.success("Proyecto actualizado correctamente.");
         
          this.Loading.hide();
          this.$state.reload();
        }
      })
  }

}

export default DesembolsoController;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/orden-proceder/orden-proceder.controller.js